<template>
  <div class="layout-main">
    <div class="openai-main">
      <div class="openai-title-wrap">
        <div class="title">Hi，我已集成了DeepSeek，很高兴见到你！</div>
        <div class="desc">
          我可以帮你写代码、读文件、写作各种创意内容，请把你的任务交给我吧~
        </div>
      </div>
      <div class="openai-wrap">
        <div class="openai-bottom">
          <div class="input-wrap">
            <div class="input-container">
              <div class="openai-input-box">
                <textarea
                  class="openai-input"
                  placeholder="给 DeepSeek 发送消息 "
                  rows="2"
                ></textarea>
                <div class="openai-div"></div>
              </div>
              <div class="cs-input-function-wrapper">
                <div
                  style="
                    flex: 1;
                    justify-content: flex-end;
                    align-items: center;
                    display: flex;
                  "
                >
                <el-button type="primary" icon="el-icon-top" circle></el-button>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Course",
  components: {},
  data() {
    return {};
  },
  methods: {
    getOpenAi() {},
  },
};
</script>

<style scoped>
.layout-main {
  width: 100%;
  /* height: 100%; */
  height: calc(-60px + 100vh);
  display: flex;
  position: relative;
}

.openai-main {
  box-sizing: border-box;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 800px;
  height: 100%;
  margin: auto;
  padding: 0 64px;
  display: flex;
  position: relative;
}

.openai-title-wrap {
  transform: translateY(-7.5vh);
  color: #000;
  text-align: center;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
  line-height: 24px;
  display: flex;

  .title {
    align-items: center;
    gap: 14px;
    margin-top: auto;
    font-size: 24px;
    font-weight: 500;
    display: flex;
  }

  .desc {
    color: #404040;
    margin: 8px 0 20px;
    font-size: 14px;
  }
}

.openai-wrap {
  transform: translateY(-7.5vh);
  max-width: 800px;
  flex-grow: 1;
  width: 100%;
  position: relative;
}

.openai-bottom {
  --padding: 14px;
  cursor: text;
  box-sizing: border-box;
  width: 100%;
  font-size: 16px;
  line-height: 28px;
  transition: box-shadow 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: none;
  background-color: transparent;
  background-color: #fff;
  border-radius: 24px;
  flex-direction: column;
  display: flex;
  position: relative;
}

.input-container {
  z-index: 1;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 10px;
  display: flex;
  overflow: hidden;

  background-color: #f3f4f6;
  box-shadow: 0px 0px 0px 0.5px #dce0e9;
  border-radius: 24px;
}

.openai-input-box {
  width: 100%;
  max-height: calc(12 * 28px);
  margin: 0 4px;
  position: relative;
}

.openai-input:focus-visible {
  border: none; /* 移除边框 */
  outline: none; /* 移除默认的蓝色轮廓 */
}

.cs-input-function-wrapper {
  --function-row-offset: 2px;
  width: calc(100% - 2px);
  padding-left: 2px;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 4px;
  display: flex;
}

.openai-input {
  resize: none;
  color: #404040;
  caret-color: #404040;
  background-color: transparent;
  position: absolute;

  font-size: inherit;
  line-height: inherit;
  word-break: break-word;
  white-space: pre-wrap;
  border: none;
  width: 100%;
  margin: 0;
  padding: 0;
  font-family: inherit;
  display: block;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: auto;
}

.openai-div {
  visibility: hidden;
  pointer-events: none;
  min-height: 56px;

  font-size: inherit;
  line-height: inherit;
  word-break: break-word;
  white-space: pre-wrap;
  border: none;
  width: 100%;
  margin: 0;
  padding: 0;
  font-family: inherit;
  display: block;
  overflow: auto;
}
</style>
